<div class="mb-5 h-10 flex flex-col justify-between">
  @if (showLearnMore()) {
    <lib-link
      [attr.data-testid]="'product-detail-' + productCode() | lowercase"
      [textCssClass]="'flex justify-center items-center text-[--color-text-primary] text-sm font-bold'"
      [link]="productDetailsLink()"
    >
      <lib-svg svg="fontawesome/list-check" class="normal mr-1" />
      {{ ['title', 'details'] | translate }}
    </lib-link>
  }
  @if (activationFee() !== 0) {
    <p class="text-[--color-text-secondary] text-xs">
      {{ activationFee() | currency: 'CHF' }} {{ ['activation_fee'] | translate }}
    </p>
  }
  @if (contractDuration() !== 0) {
    <p class="text-[--color-text-secondary] text-xs">{{ contractDuration() }} {{ ['contract_binding'] | translate }}</p>
  }
</div>
